module.exports = __webpack_public_path__ + "img/USER.a62fe38f.svg";